import { lazy, Suspense, FC } from "react";

const LoginPage = lazy(() => import("./LoginPage"));

const LoginPageLazy: FC = () => (
  <Suspense fallback={null}>
    <LoginPage />
  </Suspense>
);

export default LoginPageLazy;
